import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Riceverò dei libri a casa?',
  a: "No, è un sistema digitale ad accesso immediato. Potrai consultare tutto su telefono, tablet o PC subito dopo l'ordine."
}, {
  q: 'Le ricette sono difficili o costose?',
  a: 'Assolutamente no. Usiamo ingredienti comuni della nostra terra e la maggior parte dei piatti si prepara in meno di 15 minuti.'
}, {
  q: "Cosa succede dopo l'acquisto?",
  a: "Riceverai immediatamente un'email con il link per accedere alla tua area riservata e scaricare tutto il materiale."
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì, utilizziamo la tecnologia SSL criptata per garantirti la massima sicurezza nel pagamento.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-44">
      <div className="max-w-xl mx-auto" data-id="element-45">
        <h2 className="text-xl sm:text-3xl font-serif font-bold text-center mb-5 sm:mb-8 text-brand-text-main" data-id="element-46">
          ❓ DOMANDE FREQUENTI
        </h2>

        <div className="space-y-3" data-id="element-47">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-gold/30 rounded-xl overflow-hidden" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-sage-light transition-colors gap-4" data-id="element-49">
                <span className="font-bold text-brand-text-main text-xs sm:text-base" data-id="element-50">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-olive transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>

              {openIndex === i && <div className="px-5 pb-4 pt-0 text-xs sm:text-sm text-brand-text-muted font-medium leading-relaxed" data-id="element-52">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}